import React, { Component } from "react";
import "./navbar.scss";
import { Link } from "react-router-dom";
import $ from "jquery";
import MediaQuery from "react-responsive";
export default class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = { showMenu: false, init: "" };
  }
  moveTo(selector, position) {
    console.log(selector, position);
    let navbarHeight = $(".Navbar").height();
    if ($(selector).length > 0) {
      $("html, body").animate(
        {
          scrollTop: $(selector).offset().top - navbarHeight + position,
        },
        800
      );
    }
  }
  toggleMenu() {
    this.setState({
      showMenu: !this.state.showMenu,
      init: "OFF",
    });
  }
  componentDidMount() {
    $(window).scroll(function () {
      const nav = document.querySelector(".Navbar");
      $(window).scrollTop() > 0
        ? (nav.id = "nav-transparent")
        : (nav.id = "nav");
    });
    let hash = window.location.hash;
    if (hash == "#proyectos" || hash == "#Contactanos") {
      if (document.querySelector(".loading")) {
        document.querySelector(".loading").classList.add("none");
      }
    }
  }
  changePage() {}
  render() {
    const biabo =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173.51 73.53"><defs><style>.biabo-1{fill:#38d5ba;}</style></defs><title></title><g id="Capa_2" data-name="Capa 2"><g id="Layer_1" data-name="Layer 1"><path class="biabo-1" d="M.48,65H2.09v8.38H.48ZM0,61.77a1.28,1.28,0,0,1,.37-.92,1.19,1.19,0,0,1,.9-.39,1.27,1.27,0,0,1,.93.39,1.25,1.25,0,0,1,.38.92,1.2,1.2,0,0,1-.38.91,1.33,1.33,0,0,1-.93.37,1.25,1.25,0,0,1-.9-.37A1.23,1.23,0,0,1,0,61.77"/><path class="biabo-1" d="M5,65h1.6v1.47A2.91,2.91,0,0,1,7.7,65.19a3.41,3.41,0,0,1,1.83-.46A3.64,3.64,0,0,1,11,65a2.45,2.45,0,0,1,1,.82,3.14,3.14,0,0,1,.5,1.08,6.65,6.65,0,0,1,.14,1.47v5h-1.6V68.88A5.34,5.34,0,0,0,11,67.8a2.65,2.65,0,0,0-.36-.87,1.82,1.82,0,0,0-.66-.57,2.15,2.15,0,0,0-1-.21,2.2,2.2,0,0,0-1,.24,2.27,2.27,0,0,0-.74.64,2.85,2.85,0,0,0-.44.91A3.79,3.79,0,0,0,6.57,69v4.32H5Z"/><path class="biabo-1" d="M26.25,73.33V68.51a2.91,2.91,0,0,0-.45-1.76,1.55,1.55,0,0,0-1.32-.6,1.79,1.79,0,0,0-1.5.72,3.58,3.58,0,0,0-.55,2.2v4.26H20.82V68.6a3.07,3.07,0,0,0-.45-1.86,1.51,1.51,0,0,0-1.3-.59,1.83,1.83,0,0,0-1.5.72,3.51,3.51,0,0,0-.57,2.2v4.26H15.4V65H17v1.49a2.66,2.66,0,0,1,.89-1.21,2.54,2.54,0,0,1,1.59-.5,3,3,0,0,1,1.81.49,2.43,2.43,0,0,1,.88,1.3,2.82,2.82,0,0,1,.39-.69,2.71,2.71,0,0,1,.6-.57,3.09,3.09,0,0,1,.77-.39,3.19,3.19,0,0,1,.94-.14,3.27,3.27,0,0,1,1.4.26,2.33,2.33,0,0,1,.92.7,2.58,2.58,0,0,1,.51,1A4.9,4.9,0,0,1,27.86,68v5.3Z"/><path class="biabo-1" d="M34.32,72.09a2.78,2.78,0,0,0,1.17-.24,2.91,2.91,0,0,0,.9-.63,3.07,3.07,0,0,0,.57-.94,3.25,3.25,0,0,0,.2-1.14A3.35,3.35,0,0,0,37,68a3.2,3.2,0,0,0-.57-.94,2.78,2.78,0,0,0-2.07-.88,2.7,2.7,0,0,0-1.16.24,2.6,2.6,0,0,0-.88.64,3,3,0,0,0-.56.94,3.13,3.13,0,0,0-.21,1.15,3,3,0,0,0,.21,1.14,2.86,2.86,0,0,0,.56.94,2.74,2.74,0,0,0,2,.87m0,1.44a4.4,4.4,0,0,1-1.81-.35,4.12,4.12,0,0,1-1.39-1,4.32,4.32,0,0,1-.88-1.4,4.52,4.52,0,0,1-.32-1.68,4.61,4.61,0,0,1,.32-1.69A4.26,4.26,0,0,1,31.12,66a4.12,4.12,0,0,1,1.39-1,4.4,4.4,0,0,1,1.81-.35,4.49,4.49,0,0,1,1.83.35,4.25,4.25,0,0,1,2.29,2.37,4.61,4.61,0,0,1,.31,1.69,4.52,4.52,0,0,1-.31,1.68,4.21,4.21,0,0,1-.9,1.4,4.12,4.12,0,0,1-1.39,1,4.49,4.49,0,0,1-1.83.35"/><path class="biabo-1" d="M45.4,72.09a2.68,2.68,0,0,0,1.14-.24,2.82,2.82,0,0,0,.88-.63,3,3,0,0,0,.56-.94,3.25,3.25,0,0,0,.2-1.14A3.35,3.35,0,0,0,48,68a3.17,3.17,0,0,0-.56-.94,2.69,2.69,0,0,0-2-.88,2.8,2.8,0,0,0-1.18.24,2.64,2.64,0,0,0-.89.64,2.82,2.82,0,0,0-.57.94,3.13,3.13,0,0,0-.21,1.15,3,3,0,0,0,.21,1.14,2.73,2.73,0,0,0,.57.94,2.76,2.76,0,0,0,.89.63,2.8,2.8,0,0,0,1.18.24m-2.85,1.24H41V60.41h1.6v6a2.94,2.94,0,0,1,1.2-1.22,3.42,3.42,0,0,1,1.72-.44,4.22,4.22,0,0,1,1.76.35,3.94,3.94,0,0,1,1.37,1,4.43,4.43,0,0,1,.88,1.41,4.82,4.82,0,0,1,.31,1.69,4.73,4.73,0,0,1-.31,1.68,4.49,4.49,0,0,1-.88,1.4,3.94,3.94,0,0,1-1.37,1,4.22,4.22,0,0,1-1.76.35,3.42,3.42,0,0,1-1.72-.44,2.94,2.94,0,0,1-1.2-1.22Z"/><path class="biabo-1" d="M52,65h1.61v8.38H52Zm-.48-3.18a1.33,1.33,0,0,1,.37-.92,1.21,1.21,0,0,1,.91-.39,1.33,1.33,0,0,1,1.31,1.31,1.21,1.21,0,0,1-.39.91,1.33,1.33,0,0,1-.92.37,1.26,1.26,0,0,1-1.28-1.28"/><rect class="biabo-1" x="56.49" y="60.41" width="1.61" height="12.92"/><path class="biabo-1" d="M61,65h1.6v8.38H61Zm-.48-3.18a1.28,1.28,0,0,1,.37-.92,1.17,1.17,0,0,1,.9-.39,1.23,1.23,0,0,1,.92.39,1.26,1.26,0,0,1,.39.92,1.21,1.21,0,0,1-.39.91,1.29,1.29,0,0,1-.92.37,1.26,1.26,0,0,1-1.27-1.28"/><path class="biabo-1" d="M69.17,72.09a2.78,2.78,0,0,0,2.07-.87,2.73,2.73,0,0,0,.57-.94A3,3,0,0,0,72,69.14,3.13,3.13,0,0,0,71.81,68a2.82,2.82,0,0,0-.57-.94,2.74,2.74,0,0,0-.89-.64,2.86,2.86,0,0,0-1.18-.24,2.7,2.7,0,0,0-2,.88,3.17,3.17,0,0,0-.56.94,3.13,3.13,0,0,0-.2,1.15,3.11,3.11,0,0,0,.76,2.08,2.82,2.82,0,0,0,.88.63,2.7,2.7,0,0,0,1.16.24M73.6,65v8.38H72V71.87a3,3,0,0,1-1.21,1.22,3.48,3.48,0,0,1-1.73.44,4.18,4.18,0,0,1-1.75-.35,4,4,0,0,1-1.36-1,4.47,4.47,0,0,1-1.19-3.08,4.61,4.61,0,0,1,.31-1.69A4.43,4.43,0,0,1,66,66a4,4,0,0,1,1.36-1,4.18,4.18,0,0,1,1.75-.35,3.48,3.48,0,0,1,1.73.44A3,3,0,0,1,72,66.39V65Z"/><path class="biabo-1" d="M81.67,66.43l-.41-.08-.38,0a2.46,2.46,0,0,0-2.1.91,3.89,3.89,0,0,0-.69,2.42v3.67H76.48V65h1.61v1.64a2.66,2.66,0,0,1,1.12-1.28,3.06,3.06,0,0,1,1.67-.49,2,2,0,0,1,.79.13Z"/><path class="biabo-1" d="M83.22,65h1.61v8.38H83.22Zm-.48-3.18a1.28,1.28,0,0,1,.37-.92,1.21,1.21,0,0,1,.91-.39,1.33,1.33,0,0,1,1.31,1.31,1.21,1.21,0,0,1-.39.91,1.33,1.33,0,0,1-.92.37,1.27,1.27,0,0,1-.91-.37,1.23,1.23,0,0,1-.37-.91"/><path class="biabo-1" d="M91.42,72.09a2.78,2.78,0,0,0,1.17-.24,2.91,2.91,0,0,0,.9-.63,3.07,3.07,0,0,0,.57-.94,3.25,3.25,0,0,0,.2-1.14,3.35,3.35,0,0,0-.2-1.15,3.2,3.2,0,0,0-.57-.94,2.78,2.78,0,0,0-2.07-.88,2.7,2.7,0,0,0-1.16.24,2.6,2.6,0,0,0-.88.64,3,3,0,0,0-.56.94,3.13,3.13,0,0,0-.21,1.15,3,3,0,0,0,.21,1.14,2.86,2.86,0,0,0,.56.94,2.74,2.74,0,0,0,2,.87M95.85,65v8.38H94.26V71.87a2.9,2.9,0,0,1-1.21,1.22,3.44,3.44,0,0,1-1.72.44,4.22,4.22,0,0,1-1.76-.35,3.86,3.86,0,0,1-1.35-1,4.32,4.32,0,0,1-.88-1.4A4.52,4.52,0,0,1,87,69.14a4.61,4.61,0,0,1,.31-1.69A4.26,4.26,0,0,1,88.22,66a3.86,3.86,0,0,1,1.35-1,4.22,4.22,0,0,1,1.76-.35,3.44,3.44,0,0,1,1.72.44,2.9,2.9,0,0,1,1.21,1.22V65Z"/><path class="biabo-1" d="M149.47,10.89a13.16,13.16,0,1,0,13.15,13.16,13.17,13.17,0,0,0-13.15-13.16m0,28a14.86,14.86,0,1,1,14.85-14.85A14.87,14.87,0,0,1,149.47,38.9"/><path class="biabo-1" d="M149.47,6.4a17.65,17.65,0,1,0,17.65,17.65A17.67,17.67,0,0,0,149.47,6.4m0,37a19.35,19.35,0,1,1,19.34-19.34,19.37,19.37,0,0,1-19.34,19.34"/><path class="biabo-1" d="M149.47,1.7a22.35,22.35,0,1,0,22.35,22.35A22.37,22.37,0,0,0,149.47,1.7m0,46.39a24,24,0,1,1,24-24,24.08,24.08,0,0,1-24,24"/><rect class="biabo-1" x="31.98" y="0.35" width="1.72" height="47.09"/><rect class="biabo-1" x="36.31" y="0.35" width="1.72" height="47.09"/><rect class="biabo-1" x="40.8" y="0.35" width="1.72" height="47.09"/><polygon class="biabo-1" points="63.46 0.35 44.72 47.44 46.57 47.44 65.31 0.35 63.46 0.35"/><polygon class="biabo-1" points="68.56 0.35 49.81 47.44 51.66 47.44 70.41 0.35 68.56 0.35"/><path class="biabo-1" d="M75,30H63.38L69.06,15.7Zm1.85,4.46H61.61l1.09-2.74h13ZM78.75,39h-19l1.13-2.85H77.56ZM73.32.35,54.58,47.44h1.85l2.67-6.72H79.46l2.8,6.72h1.86L70,13.52l-.11.05,1.74-4.38,15.9,38.25h1.86L72.56,6.9l1.7-4.27,18,44.81h1.86L75.2.35Z"/><rect class="biabo-1" x="95.66" y="0.35" width="1.72" height="47.09"/><rect class="biabo-1" x="99.99" y="0.35" width="1.72" height="47.09"/><path class="biabo-1" d="M109.63,45.72h-3.47V42.78h3.43c4.92,0,10.16-3.87,10.16-11a9.8,9.8,0,0,0-4.11-7.86,10.38,10.38,0,0,0,4.11-8.17,10.79,10.79,0,0,0-3.29-7.84A9.94,9.94,0,0,0,109.85,5h-3.69V2.07h3.47a13.5,13.5,0,0,1,13,13.64,11.8,11.8,0,0,1-2.82,7.6l.59.49-.59-.49-.06.08-.54.68.67.54c.11.09,2.75,2.28,2.75,7.47a13.5,13.5,0,0,1-13,13.64m-3.47-7.6h2.53a6.38,6.38,0,1,0,0-12.76h-2.53V22.43h2.53a6.4,6.4,0,1,0,0-12.79h-2.53V6.72h3.69a8.83,8.83,0,0,1,3.83,16.42l-1.41.77,1.43.75A8.38,8.38,0,0,1,118,31.74c0,6.84-5,9.32-8.44,9.32h-3.43Zm0-11h2.53a4.66,4.66,0,1,1,0,9.32h-2.53Zm0-15.72h2.53a4.68,4.68,0,1,1,0,9.35h-2.53Zm18.18,20.72a12,12,0,0,0-2.79-8.22,13.51,13.51,0,0,0,2.79-8.15A15.24,15.24,0,0,0,109.63.35h-5.19V47.44h5.19a15.24,15.24,0,0,0,14.71-15.36"/><rect class="biabo-1" y="0.35" width="1.72" height="47.09"/><rect class="biabo-1" x="4.33" y="0.35" width="1.72" height="47.09"/><path class="biabo-1" d="M14,45.72H10.5V42.78h3.43c4.93,0,10.16-3.87,10.16-11A9.8,9.8,0,0,0,20,23.88a10.38,10.38,0,0,0,4.11-8.17A10.79,10.79,0,0,0,20.8,7.87,9.94,9.94,0,0,0,14.19,5H10.5V2.07H14A13.51,13.51,0,0,1,27,15.71a11.76,11.76,0,0,1-2.83,7.6l.59.49-.59-.49-.06.08-.54.68.67.54c.11.09,2.76,2.28,2.76,7.47A13.51,13.51,0,0,1,14,45.72m-3.47-7.6H13a6.38,6.38,0,1,0,0-12.76H10.5V22.43H13A6.4,6.4,0,1,0,13,9.64H10.5V6.72h3.69A8.83,8.83,0,0,1,18,23.14l-1.4.77,1.42.75a8.38,8.38,0,0,1,4.33,7.08c0,6.84-5.05,9.32-8.44,9.32H10.5Zm0-11H13a4.66,4.66,0,1,1,0,9.32H10.5Zm0-15.72H13a4.68,4.68,0,1,1,0,9.35H10.5ZM28.68,32.08a12,12,0,0,0-2.79-8.22,13.51,13.51,0,0,0,2.79-8.15A15.24,15.24,0,0,0,14,.35H8.78V47.44H14A15.24,15.24,0,0,0,28.68,32.08"/></g></g></svg>';
    const facebook =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.03 23.89"><defs><style>.cls-1{fill:#fff;}</style></defs><title></title><g id="Capa_2" data-name="Capa 2"><g id="Layer_1" data-name="Layer 1"><path class="cls-1" d="M24,12A12,12,0,1,0,10.14,23.89v-8.4H7.09V12h3.05V9.37c0-3,1.79-4.68,4.54-4.68a18.17,18.17,0,0,1,2.69.24v3H15.85a1.74,1.74,0,0,0-2,1.87V12h3.34l-.54,3.47h-2.8v8.4A12,12,0,0,0,24,12Z"/></g></g></svg>';
    const instagram =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.89 23.89"><defs><style>.cls-1{fill:#fff;}</style></defs><title></title><g id="Capa_2" data-name="Capa 2"><g id="Layer_1" data-name="Layer 1"><path class="cls-1" d="M11.94,2.15c3.19,0,3.57,0,4.83.07A6.67,6.67,0,0,1,19,2.63a3.8,3.8,0,0,1,1.37.9,3.5,3.5,0,0,1,.89,1.37,6.54,6.54,0,0,1,.42,2.22c0,1.26.06,1.63.06,4.82s0,3.57-.06,4.83A6.6,6.6,0,0,1,21.25,19,3.93,3.93,0,0,1,19,21.25a6.6,6.6,0,0,1-2.22.42c-1.26,0-1.64.06-4.83.06s-3.56,0-4.82-.06a6.54,6.54,0,0,1-2.22-.42,3.5,3.5,0,0,1-1.37-.89A3.8,3.8,0,0,1,2.63,19a6.67,6.67,0,0,1-.41-2.22c-.06-1.26-.07-1.64-.07-4.83s0-3.56.07-4.82A6.61,6.61,0,0,1,2.63,4.9a3.64,3.64,0,0,1,.9-1.37,3.64,3.64,0,0,1,1.37-.9,6.61,6.61,0,0,1,2.22-.41c1.26-.06,1.63-.07,4.82-.07m0-2.15C8.7,0,8.29,0,7,.07a8.7,8.7,0,0,0-2.9.56A6,6,0,0,0,.63,4.12,8.7,8.7,0,0,0,.07,7C0,8.29,0,8.7,0,11.94s0,3.65.07,4.93a8.7,8.7,0,0,0,.56,2.9A5.81,5.81,0,0,0,2,21.88a5.87,5.87,0,0,0,2.12,1.38,8.72,8.72,0,0,0,2.9.55c1.27.06,1.68.08,4.92.08s3.65,0,4.93-.08a8.72,8.72,0,0,0,2.9-.55,6.16,6.16,0,0,0,3.49-3.49,8.72,8.72,0,0,0,.55-2.9c.06-1.28.08-1.68.08-4.93s0-3.65-.08-4.92a8.72,8.72,0,0,0-.55-2.9A5.87,5.87,0,0,0,21.88,2,5.81,5.81,0,0,0,19.77.63a8.7,8.7,0,0,0-2.9-.56C15.59,0,15.19,0,11.94,0Z"/><path class="cls-1" d="M11.94,5.81a6.14,6.14,0,1,0,6.14,6.13A6.14,6.14,0,0,0,11.94,5.81Zm0,10.11a4,4,0,1,1,4-4A4,4,0,0,1,11.94,15.92Z"/><circle class="cls-1" cx="18.32" cy="5.57" r="1.43"/></g></g></svg>';
    const pinterest =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.85 23.89"><defs><style>.cls-1{fill:#fff;}</style></defs><title></title><g id="Capa_2" data-name="Capa 2"><g id="Layer_1" data-name="Layer 1"><path class="cls-1" d="M11.93,0A11.94,11.94,0,0,0,7.58,23.05a11.63,11.63,0,0,1,0-3.43L9,13.69a4.3,4.3,0,0,1-.36-1.77c0-1.66,1-2.89,2.16-2.89a1.5,1.5,0,0,1,1.52,1.68,23,23,0,0,1-1,4,1.74,1.74,0,0,0,1.77,2.16c2.12,0,3.75-2.23,3.75-5.46a4.71,4.71,0,0,0-5-4.85,5.17,5.17,0,0,0-5.39,5.18,4.67,4.67,0,0,0,.89,2.72.36.36,0,0,1,.07.34c-.08.38-.29,1.19-.33,1.36s-.18.26-.4.15c-1.49-.69-2.43-2.86-2.43-4.62C4.28,7.9,7,4.44,12.17,4.44c4.13,0,7.36,2.95,7.36,6.89,0,4.12-2.6,7.43-6.19,7.43a3.16,3.16,0,0,1-2.73-1.38l-.75,2.84a13,13,0,0,1-1.48,3.14,12.11,12.11,0,0,0,3.53.53A11.95,11.95,0,0,0,11.93,0Z"/></g></g></svg>';

    return (
      <nav className="Navbar">
        <div className="brand">
          <a
            href="/"
            className="brand-biabo"
            dangerouslySetInnerHTML={{ __html: biabo }}
          ></a>
        </div>
        <div className="content-links">
          <div className="link link-toggle">
            <div
              className={
                this.state.showMenu ? "toggle ON" : `toggle ${this.state.init}`
              }
              onClick={this.toggleMenu.bind(this)}
            >
              <div className="barra barra-1"></div>
              <div className="barra barra-2"></div>
              <div className="barra barra-3"></div>
            </div>
          </div>
          <a className="link">
            <i
              className="icono instagram"
              dangerouslySetInnerHTML={{ __html: instagram }}
            ></i>
          </a>
          <a className="link">
            <a
              target="__blank"
              href="https://www.facebook.com/Biabo.inmobiliaria"
              className="icono facebook d-block"
              dangerouslySetInnerHTML={{ __html: facebook }}
            ></a>
          </a>
          <a className="link">
            <a
              target="__blank"
              href="https://www.instagram.com/biabo.inmobiliaria/"
              className="icono facebook d-block"
              dangerouslySetInnerHTML={{ __html: instagram }}
            ></a>
          </a>
          <a className="link proyecto" href="/#Contactanos">
            Contáctanos
          </a>
          <Link to="/nosotros" className="link proyecto">
            Nosotros
          </Link>
          <a className="link proyecto" href="/#proyectos">
            Todos los proyectos
          </a>
        </div>
        <div
          className={
            this.state.showMenu ? "Menu ON" : `Menu ${this.state.init}`
          }
        >
          <img
            className="biabo-menu-img"
            src={require("../../Assets/images/iconos/biabo-footer.png")}
          ></img>
          <div className="content-link-menu">
            <div className="proyectos">
              <a
                href="/"
                className="flex-column link-proyectos"
                onClick={this.toggleMenu.bind(this)}
              >
                <span className="project" id="link-inicio">
                  Inicio
                </span>
              </a>
              <a
                className="desktop flex-column link-proyectos"
                href="/#Proyectos"
                onClick={this.toggleMenu.bind(this)}
              >
                <span className="project show-project">Proyectos</span>
              </a>
              <MediaQuery query="(max-width: 740px)">
                <div className="movil flex-column link-proyectos">
                  <span className="project show-project">Proyectos</span>
                  <div className="movil menu-links">
                    <a
                      href="/Skyna"
                      id="skyna"
                      onClick={this.toggleMenu.bind(this)}
                      className="link"
                    >
                      Skyna |
                      <a className="tel" target="_blank" href="tel:943 918 514">
                        943 918 514
                      </a>
                    </a>
                    <a
                      href="/Garden"
                      id="garden"
                      onClick={this.toggleMenu.bind(this)}
                      className="link"
                    >
                      Garden |
                      <a className="tel" target="_blank" href="tel:964 193 102">
                        964 193 102
                      </a>
                    </a>
                  </div>
                </div>
              </MediaQuery>
              <Link
                to="/nosotros"
                className="flex-column link-proyectos"
                onClick={this.toggleMenu.bind(this)}
              >
                <span className="project" id="link-nosotros">
                  Nosotros
                </span>
              </Link>
              <Link
                to="/inversionistas"
                className="flex-column link-proyectos"
                onClick={this.toggleMenu.bind(this)}
              >
                <span className="project" id="link-inversionistas">
                  Inversionistas
                </span>
              </Link>
              <Link
                to="/vende-tu-terreno"
                className="flex-column link-proyectos"
                onClick={this.toggleMenu.bind(this)}
              >
                <span className="project" id="link-vende-tu-terreno">
                  Vende tu terreno
                </span>
              </Link>
              <Link
                to="/atencion-al-cliente"
                className="flex-column link-proyectos"
                href="#"
                onClick={this.toggleMenu.bind(this)}
              >
                <span className="project" id="link-servio-al-cliente">
                  Servicio al cliente
                </span>
              </Link>
              <a
                href="/#Contactanos"
                className="flex-column link-proyectos"
                onClick={this.toggleMenu.bind(this)}
              >
                <span className="project">Contáctanos</span>
              </a>
            </div>
            <div className="desktop menu-links">
              <a
                href="/#Proyectos"
                className="link"
                id="menu-inicio"
                onClick={this.toggleMenu.bind(this)}
              >
                <span className="barra"></span>Ver todos
              </a>

              <a
                href="/Skyna"
                id="skyna"
                onClick={this.toggleMenu.bind(this)}
                className="link"
              >
                <p className="t-project">Skyna </p> | 
                <a className="tel" target="_blank" href="tel:943 918 514">
                  943 918 514
                </a>
              </a>
              <a
                href="/Garden"
                id="garden"
                onClick={this.toggleMenu.bind(this)}
                className="link"
              >
                <p className="t-project">Garden</p> | 
                <a className="tel" target="_blank" href="tel:964 193 102">
                  964 193 102
                </a>
              </a>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}
